import React, { useMemo } from 'react';

import { Box, type SxProps } from '@mui/material';
import { TableTBodyWrapper } from '@wp-block-builder/block-helpers/table-layout-components';
import {
  GLOBAL_CSS_PROPERTIES,
  useGlobalBodyBackgroundColor,
  useGlobalFontFamily,
  useGlobalLinkColor,
  useGlobalTextColor,
} from '@wp-block-builder/stores/WaypointDocumentStore/useGlobalStyles';

type Props = {
  stretchBackground?: boolean;
  children: JSX.Element | JSX.Element[];
};

export default function BodyWrapper({ stretchBackground, children }: Props) {
  const backgroundColor = useGlobalBodyBackgroundColor();
  const color = useGlobalTextColor();
  const fontFamily = useGlobalFontFamily();
  const linkColor = useGlobalLinkColor();
  const internalSx = useMemo<SxProps>(
    () => ({
      ...GLOBAL_CSS_PROPERTIES,
      backgroundColor,
      fontFamily,
      color,
      a: { color: linkColor },
    }),
    [backgroundColor, fontFamily, color, linkColor]
  );
  const internalChildren = (
    <TableTBodyWrapper>
      <tr>
        <Box component="td" sx={internalSx}>
          {children}
        </Box>
      </tr>
    </TableTBodyWrapper>
  );

  if (!stretchBackground) {
    return internalChildren;
  }
  return (
    <div
      style={{
        backgroundColor,
        containerType: 'size',
        minHeight: '100%',
      }}
    >
      {internalChildren}
    </div>
  );
}
